export default {"src":"/_next/static/media/generating-icon.225d3873.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};